/**
 * Circle Icons Hover
 */
$('ul.header__icons__circle li').hover(
    function () {
        var icontitle = $(this).find('img').attr('alt');
        $('.header__icons__title').html(icontitle, true);
    },
    function () {
        $('.header__icons__title').html('');
    }
);

/**
 * Textslider
 */
$(document).ready(function () {
    var j = 0;
    var delay = 6000;

    function cycleThru() {
        var jmax = $(".textslider ul li").length - 1;
        $(".textslider ul li:eq(" + j + ")")
            .animate({
                "opacity": "1"
            }, 600)
            .animate({
                "opacity": "1"
            }, delay)
            .animate({
                "opacity": "0"
            }, 600, function () {
                (j === jmax) ? j = 0 : j++;
                cycleThru();
            });
    }

    cycleThru();
});

/**
 * Hamburger Menu
 */

$('nav.top button.hamburger').click(function () {
    $(this).toggleClass('is-active');
    $('nav.top > ul.menu.vertical').slideToggle();
});

/**
 * Init Isotope for Portfolio
 */
$('.portfolio-grid').imagesLoaded(function () {
    var $grid = $('.portfolio-grid').isotope({
        itemSelector: '.portfolio-grid .column',
        layoutMode: 'fitRows'
    });

    // bind filter button click
    $('.portfolio .menu').on('click', 'a', function () {
        var filterValue = $(this).attr('data-filter');
        // use filterFn if matches value
        $grid.isotope({filter: filterValue});
        return false;
    });

    // change is-checked class on buttons
    $('.portfolio .menu').each(function (i, menuGroup) {
        var $menuGroup = $(menuGroup);
        $menuGroup.on('click', 'a', function () {
            $menuGroup.find('.is-checked').removeClass('is-checked');
            $(this).addClass('is-checked');
        });
    });
});

/**
 * Send contact form
 */
$("#contactform button").click(function () {
    $(document).on("submit", function (ev) {
        ev.preventDefault();
        var contactform = $("#contactform").serialize();

        $('#contactform fieldset, #contactform button').attr('disabled', true);
        $('#contactform button').html('<div class="sk-three-bounce"><div class="sk-child sk-bounce1"></div><div class="sk-child sk-bounce2"></div><div class="sk-child sk-bounce3"></div></div>', true);

        $.ajax({
            type: 'POST',
            url: monajax.ajax_url,
            data: {
                action: 'contactform_send',
                fields: contactform
            },
            success: function (data) {
                $("#contactform .success").css('display', 'block');
                $('#contactform fieldset, #contactform button').attr('disabled', false);
                $('#contactform button').html('Nachricht abschicken', true);
                $('#contactform')[0].reset();
            }
        });
    });
});

/**
 * Footer logo: Go to top
 */
$('footer img').click(function () {
    $("html, body").animate({scrollTop: 0}, "slow");
    return false;
});
